"use strict";

(() => {
  const popups = [{
    button: "header-cart-btn",
    modal: "header-cart-modal"
  }, {
    button: "header-currency-btn",
    modal: "header-currency-modal"
  }, {
    button: "header-currency-mobile-btn",
    modal: "header-currency-mobile-modal"
  }, {
    button: "footer-currency-btn",
    modal: "footer-currency-modal"
  }];
  const normalizedString = str => {
    return `#${str}`;
  };
  const closeModal = () => {
    for (let popup of popups) {
      const ref = document.querySelector(normalizedString(popup.modal));
      if (ref) ref.classList.remove("this-active");
    }
  };
  const closeModalByEsc = e => {
    if (e.code === "Escape") {
      closeModal();
      currentButton = null;
      document.activeElement.blur();
    }
  };
  let currentButton = null;
  const openModal = e => {
    e.preventDefault();
    closeModal();
    if (currentButton === e.target) {
      currentButton = null;
      return;
    }
    currentButton = e.target;
    for (let popup of popups) {
      if (currentButton.id === popup.button) {
        document.querySelector(normalizedString(popup.modal)).classList.add("this-active");
      }
    }
  };
  for (let popup of popups) {
    let ref = document.querySelector(normalizedString(popup.button));
    if (ref) ref.addEventListener("click", openModal);
  }
  const closeModalBtn = document.querySelectorAll(".modal-close-button");
  closeModalBtn.forEach(item => item.addEventListener("click", () => {
    currentButton = null;
    closeModal();
    if (item?._murmelFocusBackref) {
      item._murmelFocusBackref.focus();
    }
  }));
  document.body.addEventListener("click", function (event) {
    const targetModal = event.target.closest(".js-modal") || event.target.closest(".js-modal-btn");
    const allModals = Array.from(document.querySelectorAll(".js-modal"));
    if (!targetModal || event.target.closest(".modal-close-button")) {
      allModals.forEach(modal => modal.classList.remove("this-active"));
      currentButton = null;
      const closeButton = event.target.closest(".modal-close-button");
      if (closeButton && closeButton?.classList?.contains("js-pause-all-media")) {
        window.pauseAllMedia();
      }
      if (closeButton && closeButton?._murmelFocusBackref) {
        closeButton._murmelFocusBackref.focus();
      }
    }
  });
  window.addEventListener("keydown", closeModalByEsc);
})();